<template>
  <header
      class="flex items-center justify-between px-6 py-4 bg-white border-b-4 border-indigo-600"
  >
    <div class="flex items-center">
      <button
          @click="$emitter.emit('openSidebar')"
          class="text-gray-500 focus:outline-none"
          :class="isSidebarSlidable ? '' : 'lg:hidden'"
      >
        <svg
            class="w-6 h-6"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M4 6H20M4 12H20M4 18H11"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
        </svg>
      </button>

      <div class="hidden relative mx-4">
        <span class="absolute inset-y-0 left-0 flex items-center pl-3">
          <svg class="w-5 h-5 text-gray-500" viewBox="0 0 24 24" fill="none">
            <path
                d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
          </svg>
        </span>

        <input
            class="w-32 pl-10 pr-4 text-indigo-600 border-gray-200 rounded-md sm:w-64 focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
            type="text"
            placeholder="Search"
        />
      </div>
    </div>

    <div class="flex items-center">
      <div class="flex items-center justify-center mr-4">
        <div class="inline-flex shadow-md hover:shadow-lg focus:shadow-lg">
          <button
              class="rounded-l px-3 py-2 font-medium text-xs leading-tight uppercase border border-indigo-600 focus:outline-none focus:ring-0 transition duration-150 ease-in-out"
              :class="[
              $lang.$current === 'ru'
                ? 'bg-indigo-700 text-white'
                : 'bg-white text-indigo-600',
            ]"
              @click.prevent="$lang.$setLang('ru')"
          >
            {{ $lang.app.RU }}
          </button>
          <button
              class="rounded-r px-3 py-2 font-medium text-xs leading-tight uppercase border border-indigo-600 focus:outline-none focus:ring-0 active:bg-indigo-700 transition duration-150 ease-in-out"
              :class="[
              $lang.$current === 'kg'
                ? 'bg-indigo-700 text-white'
                : 'bg-white text-indigo-600',
            ]"
              @click.prevent="$lang.$setLang('kg')"
          >
            {{ $lang.app.KG }}
          </button>
        </div>
      </div>

      <div class="relative">
        <div
            @click="dropdownOpen = !dropdownOpen"
            class="cursor-pointer flex items-center"
        >
          <img
              class="object-cover rounded-full w-8 h-8 overflow-hidden shadow"
              src="https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=296&q=80"
              alt="Your avatar"
          />
          <div class="text-sm ml-2 leading-tight">
            <div class="font-medium text-indigo-700">{{ $store.getters.getCurrentUser.employment.surname }} {{ $store.getters.getCurrentUser.employment.name[0] }}.</div>
            <div class="text-xs text-gray-500" :title="$lang.$translate({ ru: $store.getters.getCurrentUser.employment.position.nameRu, kg: $store.getters.getCurrentUser.employment.position.nameKg })
            + ' | ' + $lang.$translate({ ru: $store.getters.getCurrentUser.employment.position.department.nameRu, kg: $store.getters.getCurrentUser.employment.position.department.nameKg })">
              {{ $lang.$translate({ ru: $store.getters.getCurrentUser.employment.position.nameRu, kg: $store.getters.getCurrentUser.employment.position.nameKg }) }}
            </div>
            <div></div>
          </div>
        </div>

        <div
            v-show="dropdownOpen"
            @click="dropdownOpen = false"
            class="fixed inset-0 z-40 w-full h-full bg-black opacity-50"
        ></div>

        <transition
            enter-active-class="transition duration-150 ease-out transform"
            enter-from-class="scale-95 opacity-0"
            enter-to-class="scale-100 opacity-100"
            leave-active-class="transition duration-150 ease-in transform"
            leave-from-class="scale-100 opacity-100"
            leave-to-class="scale-95 opacity-0"
        >
          <div
              v-show="dropdownOpen"
              class="absolute right-0 z-50 w-48 py-2 mt-2 bg-white rounded-md shadow-xl"
          >
            <router-link
                :to="{ name: 'EmployeeProfileDetail' }"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
            >
              {{ $lang.app.PROFILE }}
            </router-link>
            <div
                class="cursor-pointer block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                @click="logout"
            >
              {{ $lang.app.LOGOUT }}
            </div>
          </div>
        </transition>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      dropdownOpen: false,
    };
  },
  computed: {
    isSidebarSlidable() {
      return this.$route.meta.sidebar === 'slidable'
    },
    role() {
      return localStorage.getItem("role");
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "Login" })
      });
    },
  },
};
</script>
